import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import ControlledTags from '@/components/form/controlled-tags';
import { PERMISSION_LEVELS } from '@/lib/constants';

function CodePermissions() {
  const { t } = useTranslation();
  const {
    formState: { errors },
  } = useFormContext();

  return (
    <>
      <p className="leading-normal font-bold my-4">
        {t('label.codePermissions')}
      </p>
      <ControlledTags
        name={'permissions'}
        errors={errors}
        options={PERMISSION_LEVELS.map(({ value, i18nKey }) => ({
          value,
          i18nKey,
          tooltipText: t(`label.permissions.${value}.description`),
        }))}
        multiple={false}
      />
    </>
  );
}

export default CodePermissions;
